// Animación del footer (solo no-móvil)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;

let footerAnim = null; 
let footerST = null; 

function teardownFooterAnimation(footer) {
  if (footerAnim) {
    footerAnim.kill();
    footerAnim = null;
  }
  if (footerST) {
    footerST.kill();
    footerST = null;
  }
  if (footer) gsap.set(footer, { clearProps: "transform" });
}

function footerAnimation() {
  const footer = document.querySelector("footer");
  const main = document.querySelector("main");
  if (!footer || !main) return;

  // Si es móvil, no ejecutar y limpiar por si venimos de escritorio
  if (!isDesktop()) {
    teardownFooterAnimation(footer);
    return;
  }

  const viewportHeight = window.innerHeight;
  const footerHeight = footer.offsetHeight;

  // Limpieza previa por si se re-inicializa
  teardownFooterAnimation(footer);

  if (footerHeight > viewportHeight) {
    const difference = viewportHeight - footerHeight;

    footerAnim = gsap.to(footer, {
      y: -difference,
      ease: "power1.out",
      scrollTrigger: {
        id: "footer-st",
        trigger: main,
        start: "bottom center",
        scrub: 1
      }
    });

    // Guardamos el ScrollTrigger para poder matarlo después
    footerST = footerAnim.scrollTrigger;
  }
}

// Init
footerAnimation();

// Re-init en resize con debounce
let rAF = null;
window.addEventListener("resize", () => {
  if (rAF) cancelAnimationFrame(rAF);
  rAF = requestAnimationFrame(footerAnimation);
});
